import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHeading = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M6 4v16" }),
		/* @__PURE__ */ _jsx("path", { d: "M18 4v16" }),
		/* @__PURE__ */ _jsx("path", { d: "M6 12h12" })
	]
});
export default SvgHeading;
